import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App, Lander, Dinner, Travel, Events, Private, Wedding, Gifts} from './App';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
      	<Route index element={<Lander />} />
      	<Route path="wedding" element={<Wedding />} />
        <Route path="wedding-gifts" element={<Gifts />} />
   		  <Route path="adventures" element={<Travel />} />
      </Route>
    </Routes>
  </BrowserRouter>
);